export const CopyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3158 0.1875H1.47368C0.663158 0.1875 0 0.842045 0 1.64205V11.8239H1.47368V1.64205H10.3158V0.1875ZM12.5263 3.09659H4.42105C3.61053 3.09659 2.94737 3.75114 2.94737 4.55114V14.733C2.94737 15.533 3.61053 16.1875 4.42105 16.1875H12.5263C13.3368 16.1875 14 15.533 14 14.733V4.55114C14 3.75114 13.3368 3.09659 12.5263 3.09659ZM12.5263 14.733H4.42105V4.55114H12.5263V14.733Z"
        fill="#019797"
      />
    </svg>
  );
};
